import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

/** Browser-local provenance, not a replacement for server workflow status. */
export const initialHouseholdSetupStorageKey = (householdId: string) =>
  `${LOCAL_STORAGE_KEYS.INITIAL_HOUSEHOLD_SETUP}:${householdId}`;
